module.exports = __webpack_public_path__ + "img/stores.ee989e5c.png";